import { Navigate, Outlet } from "react-router";
import { useAuth } from "../contexts/AuthContext";
import { needsOauthRegistration } from "./oauthRegistration";
import { PATHS } from "./paths";

/**
 * Гард вкладок приложения (#1279): OAuth-аккаунт без анкеты уводим в визард
 * регистрации, а не в ленту с окном «Заполните анкету». Стоит только над
 * вкладками (лента, чаты, профиль, «Куда сходить») — поддержка и подтверждение
 * оплаты остаются доступны.
 */
export function OAuthRegistrationGate() {
    const { user } = useAuth();
    if (needsOauthRegistration(user)) {
        return <Navigate to={PATHS.registerComplete} replace />;
    }
    return <Outlet />;
}
